export default __webpack_public_path__ + "static/media/1.4ee06877.mp3";